import momentTz from "moment-timezone";
import moment from "moment";
import "moment/dist/locale/pt-br";
import { initializeApp } from "firebase/app";
import { initializeFirestore, CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { Crisp } from "crisp-sdk-web";

// Configurações que podem rodar imediatamente
Crisp.configure("b628bc87-f16d-42c4-912a-76d3f665027a", {
  autoload: false,
});
momentTz.tz.setDefault("America/Sao_Paulo");
moment.locale("pt-br");

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY, // Corrigido para Vite
  authDomain: `${process.env.FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
});
export const auth = getAuth(app);
setPersistence(auth, indexedDBLocalPersistence);

// Aponta APENAS as *functions* para o emulador local quando a flag do env está
// ligada (FIREBASE_FUNCTIONS_EMULATOR=true). auth/firestore seguem intocados,
// apontando para o projeto configurado nos FIREBASE_* do env.
if (process.env.FIREBASE_FUNCTIONS_EMULATOR === "true") {
  connectFunctionsEmulator(getFunctions(app), "localhost", 5001);
}
